import styled, { css } from 'styled-components';
import Link from 'client/components/Link';
import { cssColorValue, semanticColors } from '@spotify-internal/encore-web';

function getLinkColor(
  isTransparent: boolean,
  isScalableAnalyticsEnabled: boolean
) {
  return isScalableAnalyticsEnabled && !isTransparent
    ? cssColorValue(semanticColors.textSubdued)
    : 'rgba(255, 255, 255, 0.8)';
}

export const StyledNavLink = styled(Link)<{
  isActive?: boolean;
  fontSize?: number;
  isTransparent: boolean;
  isScalableAnalyticsEnabled?: boolean;
}>`
  position: relative;
  display: inline-flex;
  align-items: center;
  color: ${({ isActive, isTransparent, isScalableAnalyticsEnabled }) =>
    isActive
      ? cssColorValue(semanticColors.textBase)
      : getLinkColor(isTransparent, isScalableAnalyticsEnabled)};
  font-weight: bold;
  font-size: ${({ fontSize }) => fontSize || 16}px;

  &:hover,
  &:focus,
  &:active,
  &:active:focus {
    color: #fff;
    text-decoration: none;
  }

  ${({ isScalableAnalyticsEnabled, isTransparent }) =>
    isScalableAnalyticsEnabled &&
    css`
      &:active {
        color: ${isTransparent
          ? cssColorValue(semanticColors.textBase)
          : cssColorValue(semanticColors.textSubdued)};
        text-decoration: none;
      }

      &:hover {
        text-decoration: none;
        color: ${cssColorValue(semanticColors.textBase)};
      }
    `}

  @media (max-width: 968px) {
    font-size: 16px;
  }
`;
